export default __webpack_public_path__ + "static/media/day-8.52282337.jpg";